'use client';
import dynamic from 'next/dynamic';
import { Container } from '@weareconceptstudio/core';

//* Styles
import MacroeconomicIndicatorsTemplateStyle from './style';

//* Components
import NewHeroSection from '../../BusinessRegistration/components/NewHeroSection';
const PublicationsGlobalSection = dynamic(() => import('@/sections/PublicationsGlobalSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const ProductSection = dynamic(() => import('../components/ProductSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const KeyFactsSection = dynamic(() => import('@/modules/DiscoverArmenia/WhyArmenia/components/KeyFactsSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const ChartSection = dynamic(() => import('@/sections/ChartSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const StackedBarChart = dynamic(() => import('@/sections/ChartSection/components/StackedBarChart'), {
	ssr: false,
});
const FAQSection = dynamic(() => import('@/sections/FAQSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const RangeColumnChart = dynamic(() => import('@/sections/ChartSection/components/RangeColumnChart'), {
	ssr: false,
});

const MacroeconomicIndicatorsTemplate = ({ pageData }) => {
	const { content, faqs, publications } = pageData;
	const { hero, product, growth, structure } = content;

	const formatted = growth?.items?.map(({ additional_info }, index) => {
		const { date, value } = additional_info;

		const isNegative = value < 0;

		return {
			date,
			value: isNegative ? 0 : value,
			openValue: isNegative ? value : 0,
			value2: isNegative ? value - 0.5 : value + 0.5,
			openValue2: isNegative ? value - 0.5 - 4 : value + 0.5 + 4,
			isNegative,
			id: index,
		};
	});
	return (
		<MacroeconomicIndicatorsTemplateStyle className={`${!publications.length > 0 && !faqs.length > 0 ? 'publications-section-margin' : ''}`}>
			<NewHeroSection
				title={hero.title}
				description={hero.description}
				desktop_image={hero.desktop_image}
				mobile_image={hero?.mobile_image}
			/>

			<ProductSection
				title={product.title}
				subtitle={product.subtitle}
				description={product.description}
			/>

			<KeyFactsSection items={hero?.items} />

			<ChartSection
				{...growth}
				items={formatted}
				Chart={RangeColumnChart}
				isBlackBackgroundVersion
				className='growth-chart'
			/>

			<ChartSection
				{...structure}
				hideXAxisLabel
				Chart={StackedBarChart}
				isBlackBackgroundVersion
				isLegendSection
			/>

			<Container>
				<PublicationsGlobalSection
					publications={publications}
					isPublicationGridVersion
					publicationsTitle='publications'
				/>
			</Container>

			<FAQSection items={faqs} />
		</MacroeconomicIndicatorsTemplateStyle>
	);
};

export default MacroeconomicIndicatorsTemplate;
